
const state = {
  contact:"请输入联系人",
  email:"请输入邮箱",
  tel:"请输入联系电话",
  mob:"请输入联系手机",
  matterCode:"请输入物料编码",
  matterDesc:"请输入物料描述",
  matterGrop:"请选择物料组",
  matterType:"请选择物料类型",
  supplierCode:"请输入供应商编码",
  supplierDesc:"请输入供应商描述",
  customerCode:"请输入客户编码",
  customerDesc:"请输入客户描述",
  factoryCode:"请输入工厂编码",
  factoryDesc:"请输入工厂描述",
  factorySelect:"请选择工厂",
  fstockCode:"请输入库存地点编码",
  fstockDesc:"请输入库存地点描述",
  fstock:"请选择库存地点",
  supplier:"请输入供应商编码或描述",
  customer:"请输入客户编码或描述",
  matter:"请输入物料编码或描述",
  company:"请输入公司编码或名称",
  factory:"请输入工厂编码或描述",
  inventory:"请输入库存地点编码或描述",
  materailVoucherNo:"请输入单号",
  companySelect:"请选择公司",
  address:"请输入送货地址",
  companyCode:"请输入公司编码",
  companyDesc:"请输入公司名称",
  remark:"请输入备注信息",
};
const mutations = {};
const actions = {

};
export default{
  namespaced: true,
  state,
  mutations,
  actions
}
